import { Grid, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import "./gridControls.scss";

const GridLabel = (props) => {
  return (
    <div className="grid-container">
      <Tooltip title={props.value} arrow placement="right-start" >
        <Typography
          className="grid-label"
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            textAlign: "left",
            color: "#152C73",
            fontFamily: "Arial",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "normal"
          }}
        >
          {props.value}
        </Typography>
      </Tooltip>
    </div>
  );
};

export default GridLabel;
